/* eslint-disable */
/* TODO: If you edit this file remove eslint-disable and fix linting errors in this file. */
(function () {
  'use strict';

  var app = angular.module('knockApp');

  app.directive('dateSelector', function () {
    return {
      restrict: 'E',
      templateUrl: '/angular/views/controls/date-selector.html',
      require: 'ngModel',
      scope: {
        ngModel: '=',
        placeholder: '@?',
        hideIcon: '=?',
        isRequired: '=?'
      },
      controller: [
        '$scope',
        function ($scope) {
          $scope.datePickerOpen = false;
          $scope.placeholder = $scope.placeholder || 'Monday, Jan 1, 2016';
        }
      ]
    };
  });
})();
